import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { relationshipSummaryModel } from '~/models';
import { selectors } from '~/store/state-selectors';
const EMPTY_AGREEMENTS = [];
export const useClientAgreementsForConnect = function useClientAgreementsForConnect(clientId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const isVendor = useStore(selectors.user.isVendor);
    const businessId = useStore(selectors.user.businessId);
    const { data, isLoading, isError } = useQueryState({
        queryKey: [
            QueryKeys.ClientAgreementsForConnect,
            businessId,
            clientId
        ],
        queryFn: async ()=>{
            if (businessId == null) return EMPTY_AGREEMENTS;
            const summaries = await api.relationship.getSummaries({
                businessId,
                type: 'agreement',
                isVendor,
                customerId: clientId
            });
            return summaries.filter((summary)=>relationshipSummaryModel.agreementStatus(summary) === relationshipSummaryModel.AgreementStatus.Active).map((summary)=>({
                    id: relationshipSummaryModel.id(summary),
                    name: relationshipSummaryModel.displayedTitle(summary, isVendor) || relationshipSummaryModel.customerName(summary)
                }));
        },
        enabled: enabled && !!clientId && businessId != null,
        refreshOnHookMount
    });
    return {
        agreements: data !== null && data !== void 0 ? data : EMPTY_AGREEMENTS,
        isLoading,
        isError
    };
};
